import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Controller } from 'react-hook-form'
import { Card, Col, Form, Row } from 'react-bootstrap'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
// import { Circles } from 'react-loader-spinner'
import { createDefaultMaskGenerator, MaskedInput } from 'react-hook-mask'
import cardNumberImage from '../../assets/img/cardimgpppp.png'
import backcvvv from '../../assets/img/backcvvv.png'
import { Circles } from 'react-loader-spinner'

const cardnumbermask = createDefaultMaskGenerator('9999 9999 9999 9999')
const expirymask = createDefaultMaskGenerator('99/99')
const cvvmask = createDefaultMaskGenerator('9999')
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
function PaymentGateDc(props) {
    const { errors, register, control, onSubmit, isSubmittingForm, setFocus, extendBtn, returnClockTimer, retunnValidateTicket, loader, parkingBtnTxt } = props
    //const { errors, register, control, onSubmit, isSubmittingForm, setFocus ,faciltyData} = props
    const todayDt = new Date()
    // const today = (todayDt.getFullYear() + '' + (todayDt.getMonth() + 1)).slice(2)
    const todayMM = (todayDt.getMonth() + 1) < 10 ? '0' + (todayDt.getMonth() + 1) : (todayDt.getMonth() + 1)
    const todayYY = (todayDt.getFullYear() + '').slice(2)

    const phone = localStorage.getItem('phone')

    useEffect(() => {
        setFocus('phone')
        // console.log(phone)
    }, [setFocus])

    const validateExpiry = (MMYY) => {
        // let newArr = []
        // let newArr2 = []
        // for(let x = 0; x<4; x++) {
        //     let ar = MMYY.split('')
        //     if(x<2) {
        //         newArr.push(ar[x])
        //     } else {
        //         newArr2.push(ar[x])
        //     }
        // }
        // console.log(parseInt(today), parseInt([...newArr2, ...newArr].join('')),
        // parseInt(today) <= parseInt([...newArr2, ...newArr].join('')), 'nnn')
        // return parseInt(today) <= parseInt([...newArr2, ...newArr].join(''))

        let mm = MMYY.slice(0, 2)
        let yy = MMYY.slice(Math.max(2, 2))

        if (Number(yy) > Number(todayYY)) {
            return true
        } else if ((Number(yy) == Number(todayYY)) && Number(mm) >= Number(todayMM)) {
            return true
        } else {
            return false
        }
    }
    const mainForm = () => {
        return (
            <>
                <section className="my-3 p-3 pt-1">

                    {/* {faciltyData?.payable_amount > 0 &&   */}
                    <>
                        <p className='fw-normal'>Enter Payment Details</p>
                        {((!phone || phone === 'undefined' || phone === undefined) && extendBtn) ?
                            <Form.Group >
                                <Form.Label className='paymentCardDetials small'>Phone Number</Form.Label>
                                <Controller type="text" autoComplete="off"
                                    name='phone'
                                    className="form-control"
                                    id='phone'
                                    maxLength={10}
                                    control={control}
                                    minLength={10}
                                    placeholder='Phone Number'
                                    {...register('phone',
                                        {
                                            required: { value: true, message: 'This field is required' },
                                            minLength: { value: 10, message: 'Minimum 10 characters allowed' },
                                            maxLength: { value: 10, message: 'Maximum 10 characters allowed' },
                                        })}
                                    render={({ field }) => <MaskedInput
                                        maskGenerator={phoneMaskGenerator}
                                        {...field}
                                        id="phone"
                                        inputMode="numeric"
                                        maxLength={14}
                                        title="Enter a valid Phone number"
                                        className="form-control"
                                        onInvalid={e => e.target.setCustomValidity('Please enter a valid phone number')}
                                        onInput={e => e.target.setCustomValidity('')}
                                        placeholder="(123)-555-1234"
                                    />
                                    }
                                />
                                {errors?.phone && <Form.Text className="text-danger header-s">{errors?.phone?.message}</Form.Text>}
                            </Form.Group> : ''}
                        <Form.Group >
                            <Form.Label className='paymentCardDetials small'>Name on Card</Form.Label>
                            <Form.Control type="text" autoComplete="off"
                                name='name_on_card'
                                className="form-control"
                                id='name_on_card'
                                maxLength={20}
                                minLength={1}
                                placeholder="Enter Your Name"
                                {...register('name_on_card',
                                    {
                                        required: { value: true, message: 'This field is required' },
                                    })} />
                            {errors?.name_on_card && <Form.Text className="text-danger header-s">{errors?.name_on_card?.message}</Form.Text>}
                        </Form.Group>

                        <Form.Group >
                            <Form.Label htmlFor="cardNumber" className='paymentCardDetials small'>Card Number</Form.Label>
                            <Controller
                                name="card_number"
                                type="text"
                                id="card_number"
                                inputMode="numeric"
                                control={control}
                                rules={{
                                    pattern: { value: /[0-9]{14}/, message: 'Please enter a valid Card Number' },
                                    required: { value: true, message: 'This field is required' },
                                    minLength: { value: 14, message: 'Please enter a valid Card Number' },
                                    maxLength: { value: 16, message: 'Please enter a valid Card Number' },
                                }}

                                render={({ field }) => <span className='cardNumberCardImage d-block'> <MaskedInput
                                    maskGenerator={cardnumbermask}
                                    autoComplete="off"
                                    pattern="[0-9]{16,19}"
                                    maxLength='19'
                                    {...field}
                                    id="card_number"
                                    inputMode="numeric"
                                    title="Card no. should be 15-16 digit numberic"
                                    className="form-control"
                                    onInvalid={e => e.target.setCustomValidity('Please enter a valid card number')}
                                    onInput={e => e.target.setCustomValidity('')}
                                    placeholder="Enter Card Number"
                                /><img src={cardNumberImage} className='imgCardfront' alt="card" /></span>}
                            />
                            {errors?.card_number && <Form.Text className="text-danger header-s">{errors?.card_number?.message}</Form.Text>}
                        </Form.Group>

                        <Row>
                            {/* <Col>
                            <Form.Group >
                                <Form.Label htmlFor="ExpMonth" className='paymentCardDetials small'>Exp Month</Form.Label>
                                <input type="tel" className="form-control" name='exp_month' data-token="exp_month" placeholder="MM" maxLength="2"
                                    {...register('exp_month', {
                                        pattern: { value: /[0-9]{2}/, message: 'Please enter a valid Exp Month' },
                                        required: { value: true, message: 'Please enter a valid Exp Month' },
                                        minLength: { value: 2, message: 'Please enter a valid Exp Month' },
                                        maxLength: { value: 2, message: 'Please enter a valid Exp Month' },
                                    })} />
                                {errors?.exp_month && <Form.Text className="text-danger header-s">{errors?.exp_month?.message}</Form.Text>}
                            </Form.Group>
                        </Col> */}
                            <Col>
                                <Form.Group>
                                    <Form.Label htmlFor="expiry" className='paymentCardDetials small'>Expiry Date</Form.Label>
                                    <Controller
                                        name="expiry"
                                        type="text"
                                        inputMode="numeric"
                                        id="expiry"
                                        control={control}
                                        rules={{
                                            pattern: { value: /^(0[1-9]|1[0-2])\d{2}$/, message: 'Please enter a valid date' },
                                            required: { value: true, message: 'This field is required' },
                                            minLength: { value: 4, message: 'Please enter a valid date' },
                                            maxLength: { value: 5, message: 'Please enter a valid date' },
                                            validate: (value) => {
                                                let valid = validateExpiry(value)
                                                if (!valid) {
                                                    return 'Please enter a valid date'
                                                }
                                            },
                                        }}

                                        render={({ field }) => <span className='cardNumberCardImage'> <MaskedInput
                                            maskGenerator={expirymask}
                                            autoComplete="off"
                                            pattern='/^(0[1-9]|1[0-2])\d{2}$/'
                                            maxLength='5'
                                            {...field}
                                            inputMode="numeric"
                                            id="expiry"
                                            title="Enter a valid Expiry Date in MM/YYYY format"
                                            className="form-control"
                                            onInvalid={e => e.target.setCustomValidity('Please enter a valid expiry date')}
                                            onInput={e => e.target.setCustomValidity('')}
                                            placeholder="MM/YY"
                                        /></span>}
                                    />

                                    {errors?.expiry && <Form.Text className="text-danger header-s">{errors?.expiry?.message}</Form.Text>}
                                </Form.Group>
                            </Col>
                            {/* <Col>
                            <Form.Group >
                                <Form.Label htmlFor="ExpYear" className='paymentCardDetials small'>Exp Year</Form.Label>
                                <input type="tel" className="form-control" name='exp_year' data-token="exp_year" placeholder="YYYY" maxLength="4"
                                    {...register('exp_year', {
                                        pattern: { value: /[0-9]{4}/, message: 'Please enter a valid Exp Year' },
                                        required: { value: true, message: 'Please enter a valid Exp Year' },
                                        minLength: { value: 4, message: 'Please enter a valid Exp Year' },
                                        maxLength: { value: 4, message: 'Please enter a valid Exp Year' },
                                    })} />
                                {errors?.exp_year && <Form.Text className="text-danger header-s">{errors?.exp_year?.message}</Form.Text>}
                            </Form.Group>
                        </Col> */}
                            <Col>
                                <Form.Group>
                                    <Form.Label htmlFor="CVV" className='paymentCardDetials small'>CVC/CVV</Form.Label>
                                    <Controller
                                        name="cvv"
                                        type="password"
                                        id="Cvv"
                                        inputMode="numeric"
                                        control={control}
                                        className='d-inline-flex'
                                        rules={{
                                            pattern: { value: /[0-9]{3,4}/, message: 'Please enter a valid CVV' },
                                            required: { value: true, message: 'This field is required' },
                                            minLength: { value: 3, message: 'Please enter a valid CVV' },
                                            maxLength: { value: 4, message: 'Please enter a valid CVV' },
                                        }}

                                        render={({ field }) => <span className='cardNumberCardImage d-block'> <MaskedInput
                                            maskGenerator={cvvmask}
                                            autoComplete="off"
                                            type={'password'}
                                            pattern='/[0-9]{3,4}/'
                                            maxLength='4'
                                            {...field}
                                            inputMode="numeric"
                                            id="Cvv"
                                            title="Enter a valid cvv"
                                            className="form-control d-inline-flex"
                                            onInvalid={e => e.target.setCustomValidity('Please enter a valid CVV')}
                                            onInput={e => e.target.setCustomValidity('')}
                                            placeholder="CVV"
                                        /><img src={backcvvv} className='imgCardfront2' alt="card" /></span>}
                                    />

                                    {errors?.cvv && <Form.Text className="text-danger header-s">{errors?.cvv?.message}</Form.Text>}
                                </Form.Group>
                            </Col>
                        </Row>
                    </>
                    {/* } */}
                    {!extendBtn ? <div className="mt-3">
                        <button type="submit" name="submit" className="btn w-100 my-4 text-white bg-primary" style={{opacity: (isSubmittingForm ? true : loader) ? '0.8' : '1'}} onClick={onSubmit} disabled={(isSubmittingForm) ? true : loader} >
                            <div className='d-flex justify-content-center align-items-center'>
                                <h5 className='mb-0 fw-bold'>{extendBtn === true ? 'Extend' : parkingBtnTxt ? 'Pay to Park' : 'Start Parking'}</h5><span className='ms-2'>
                                    {(isSubmittingForm ? true : loader) ? <Circles
                                        height="20"
                                        width="20"
                                        style={{ display: 'inline-block' }}
                                        color="#ffffff"
                                        ariaLabel="circles-loading"
                                        visible={true}
                                    /> : null}
                                </span>
                            </div>
                        </button>
                    </div> : ''}
                </section>
            </>
        )
    }
    return (
        <div>
            {extendBtn === true ? <>
                <Card className='m-2 paymentCardRadious p-2'>{mainForm()}</Card>
                {returnClockTimer()}
                <Row className='mb-4 m-auto w-100 justify-content-center'>
                    {retunnValidateTicket()}
                    <div className="mt-3">
                        <button type="submit" name="submit" className="btn w-100 text-white bg-primary" style={{opacity: (isSubmittingForm ? true : loader) ? '0.8' : '1'}} onClick={onSubmit} disabled={(isSubmittingForm) ? true : loader} >
                            <div className='d-flex justify-content-center align-items-center'>
                                <h5 className='mb-0 fw-bold'>{extendBtn === true ? 'Extend' : 'Start Parking'}</h5><span className='ms-2'>
                                    {(isSubmittingForm ? true : loader) ? <Circles
                                        height="20"
                                        width="20"
                                        style={{ display: 'inline-block' }}
                                        color="#ffffff"
                                        ariaLabel="circles-loading"
                                        visible={true}
                                    /> : null}
                                </span>
                            </div>
                        </button>
                    </div>
                </Row>
            </> : <Form onSubmit={onSubmit}>
                {mainForm()}
            </Form>}
        </div >
    )
}

PaymentGateDc.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    errors: PropTypes.object,
    faciltyData: PropTypes.object,
    register: PropTypes.func,
    control: PropTypes.object,
    onSubmit: PropTypes.func,
    isTokenApiStarts: PropTypes.bool,
    isSubmittingForm: PropTypes.bool,
    extendBtn: PropTypes.bool,
    setFocus: PropTypes.func,
    returnClockTimer: PropTypes.func,
    retunnValidateTicket: PropTypes.func,
    parkingBtnTxt: PropTypes.bool,
}

PaymentGateDc.defaulProps = {
    dispatch: noop,
    loader: false,
    isFetching: false,
    faciltyData: EMPTY_OBJECT,
    totalHoursLength: EMPTY_OBJECT,
    partner: '',
    totalInputValues: EMPTY_OBJECT,
    onSubmit: noop,
    isTokenApiStarts: false,
    isSubmittingForm: false,
    extendBtn: false,
    setFocus: noop,
    returnClockTimer: noop,
    retunnValidateTicket: noop,
    parkingBtnTxt: '',
}

function mapStateToProps({ transientReducer }) {
    return {
        loader: transientReducer?.loader,
        isFetching: transientReducer?.isFetching
    }
}
export default connect(mapStateToProps)(PaymentGateDc)